<template>
  <div
  class="crx-input mod-parent">

    <v-menu
    ref="bestBeforeMenu"
    :close-on-content-click="false"
    v-model="bestBeforeMenu"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    >

      <template v-slot:activator="{ on }">
        <v-btn
          icon
          small
          v-on="on"
        >
          <v-icon
          small
          :color="combinedDateValid ? 'text' : 'textDisabled'">
            event
          </v-icon>
        </v-btn>
      </template>

      <v-date-picker v-model="pickerDate" @input="bestBeforeMenu = false" no-title color="color1"></v-date-picker>

    </v-menu>

    <the-mask 
    mask="##/##/####" 
    type="text" 
    :masked="true" 
    v-model="textDate"
    placeholder="dd/mm/yyyy"
    :class="textDateValid ? '': 'textSecondary--text'"
    @focus.native="focussed = true"
    @blur.native="onBlur">
    </the-mask>

    <the-mask 
    mask="##:##" 
    type="text" 
    :masked="true" 
    v-model="textTime"
    :class="textTimeValid ? '': 'textSecondary--text'"
    placeholder="hh:mm">
    </the-mask>

    <v-menu v-if="!combinedDateValid" offset-y open-on-hover transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <v-avatar v-on="on" size="20" class="ml-2">
          <v-icon color="pink" size="16">mdi-information-outline</v-icon>
        </v-avatar>

      </template>
      <v-card outlined class="elevation-0 pa-6" max-width="350px">
        <div class="text-center mb-4 title">
          <v-icon size="30" color="text">mdi-information-outline</v-icon>
          Error
        </div>
        <div class="">
          Please fill out both a correct date and time
        </div>
      </v-card>
    </v-menu>

  </div>
</template>

<script>
/*
This component takes date_time as UTC, displays it in local time, as spits it back as UTC.
Meant as a perfect interface to the database. Works best when the date prop has no seconds attatched to it. Seconds = 00.
*/
import {TheMask} from 'vue-the-mask'

export default {
  props: ['date'],
  components: {TheMask},
  data () {
    return {
      focussed: false,
      textDate: null,
      pickerDate: null,
      bestBeforeMenu: false,
      showBorder: true,
      textTime: null
    }
  },
  computed: {
    textDateValid () {
      return this.$moment(this.textDate, 'DD/MM/YYYY', true).isValid()
    },
    textTimeValid () {
      return this.$moment(this.textTime, 'HH:mm', true).isValid()
    },
    combinedDate () {
      if (this.textDateValid && this.textTimeValid) {
        return this.$moment(this.textDate, 'DD/MM/YYYY').format('YYYY-MM-DD') + 'T' + this.$moment(this.textTime, 'HH:mm').format('HH:mm') + ':00'
      }
      return null
    },
    combinedDateValid () {
      return this.$moment(this.combinedDate, 'YYYY-MM-DDTHH:mm:ss', true).isValid()
    }
  },
  watch: {
    date: {
      immediate: true,
      handler (nv) {
        // this is exactly as your db will give it to you
        if (this.$moment(nv, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]', true).isValid()) {
          this.textDate = this.$moment.utc(nv, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]').local().format('DD/MM/YYYY')
          this.textTime = this.$moment.utc(nv, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]').local().format('HH:mm')
        }
        if (!this.focussed) {
          // triggered when using picker
          if (this.$moment(nv, 'YYYY-MM-DD', true).isValid()) {
            this.textDate = this.$moment(nv, 'YYYY-MM-DD').format('DD/MM/YYYY')
          }
        }
      }
    },
    textDate (nv) {
      var minDate = this.$moment('1000-01-01', 'YYYY-MM-DD')
      if (this.$moment(nv, 'DD/MM/YYYY', true).isValid() && this.$moment(nv, 'DD/MM/YYYY', true).isAfter(minDate)) {
        this.pickerDate = this.$moment(nv, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
        // for convenience set the time if it is not yet set.
        if (!this.textTimeValid) {
          this.textTime = this.$moment().format('HH:mm')
        }
      }
    },
    combinedDate: {
      handler (nv) {
        this.$emit('update:date', this.$moment(nv).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'))
      }
    },
    pickerDate: {
      handler (nv) {
        this.textDate = this.$moment(nv, 'YYYY-MM-DD', true).format('DD/MM/YYYY')
      }
    }
  },
  methods: {
    onBlur () {
      this.focussed = false
      // this will clear whats left in the text field when blurring if invalid e.g. "5/"
      if (!this.$moment(this.textDate, 'DD/MM/YYYY', true).isValid()) {
        this.textDate = null
      }
    },
    showMenu () {
      this.bestBeforeMenu = true
    }
  }
}
</script>

<style scoped>
.mod-parent {
  flex-direction: row;
  align-items: center;
}
</style>
